import React, { useState, useRef } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const MobilePhoneNumberInput = ({ value, onChange, onKeyDown, disabled, darkMode }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (inputRef.current) {
                inputRef.current.blur();
            }
            onChange({ target: { name: 'phone', value: event.target.value } });
            setIsExpanded(false);
        }
    };

    const clearInput = () => {
        onChange({ target: { name: 'phone', value: '' } });
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleExpand = () => {
        setIsExpanded(true);
    };

    const handleCollapse = () => {
        setIsExpanded(false);
    };

    return (
        <div className="expandable-input-container">
            {isExpanded ? (
                <div className="expanded-input">
                    <div className="custom-phone-input input-wrapper">
                        <PhoneInput
                            defaultCountry="us"
                            value={value}
                            onChange={(phone) => onChange({ target: { name: 'phone', value: phone } })}
                            placeholder="Enter phone number"
                            inputProps={{
                                ref: inputRef,
                                onKeyDown: handleKeyDown || onKeyDown,
                                disabled: disabled,
                                className: 'mobile-clearable-input'
                            }}
                            containerClass="phone-input-container"
                        />
                        {value && (
                            <button
                                className="clear-input-button visible"
                                onClick={clearInput}
                                type="button"
                                aria-label="Clear phone input"
                            >
                                ×
                            </button>
                        )}
                    </div>
                    <button onClick={handleCollapse} className="done-button">Done</button>
                </div>
            ) : (
                <div className="collapsed-input-wrapper">
                    <div className={`collapsed-input ${darkMode ? 'dark-mode' : ''}`} onClick={handleExpand}>
                        {value || "Enter phone number"}
                    </div>
                    {value && (
                        <button
                            className="clear-input-button visible"
                            onClick={clearInput}
                            type="button"
                            aria-label="Clear phone input"
                        >
                            ×
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default MobilePhoneNumberInput;